<template>
  <div class="mt-3" style="margin: 0 auto; max-width: 800px;">
    <div v-if="this.error != ''">
      <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
    </div>
    <div v-if="this.$store.state.cart.length == 0">
      <h2 style="text-align: center;">Your cart is empty</h2>

      <p @click="home" class="link" style="text-align: center;">Continue browsing</p>
    </div>
    <div v-if="this.$store.state.cart.length > 0">
      <v-container
        v-for="(item, index) in this.cartItems"
        :key="item.id"
        style="padding: 0px; margin: 0px;"
      >
        <h2 style="text-align: center;" class="mb-3">{{item.title}}</h2>
        <div style="width: 100px; margin: 0 auto; text-align: center;" class="mb-1">
          <img
            v-bind:src="item.thumbnail"
            style="width: 100px; margin: 0 auto; text-align: center;"
          />
        </div>

        <v-row no-gutters class="ml-5 mr-5 cartBox" style="text-align: center;">
          <v-col cols="12" sm="1" md="1" lg="1">
            <p>{{item.kind}}</p>
          </v-col>

          <v-col cols="12" sm="2" md="2" lg="2">
            <p>
              <span style="font-weight: bold;">Size:</span>
              {{item.size}}
            </p>
          </v-col>

          <v-col cols="12" sm="6" md="5" lg="5" class="mb-4">
            <v-btn
              class
              style="box-shadow: 0 0 5px rgb(150, 150, 150); min-width: 25px; height: 25px;"
            >Quantity: {{item.quantity}}</v-btn>
            <v-btn
              class="ml-2"
              style="box-shadow: 0 0 5px rgb(150, 150, 150); min-width: 25px; height: 25px;"
              color="success"
              @click="increaseQuantity(item)"
            >+</v-btn>
            <v-btn
              class="ml-1"
              style="box-shadow: 0 0 5px rgb(150, 150, 150); min-width: 25px; height: 25px;"
              color="error"
              @click="decreaseQuantity(item)"
            >-</v-btn>
          </v-col>

          <v-col cols="12" sm="2" md="3" lg="3">
            <p>
              <span style="font-weight: bold;">Price:</span>
              ${{item.dollarAmount}}
            </p>
          </v-col>

          <v-col cols="12" sm="1" md="1" lg="1">
            <v-btn
              class="ml-1 mb-2"
              style="box-shadow: 0 0 5px rgb(150, 150, 150); min-width: 25px; height: 25px;"
              color="error"
              @click="deleteItem(item, index)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-col>
          <div style="height: 1px; width: 100%;background-color: black;"></div>
        </v-row>
      </v-container>
      <v-container>
        <p
          class="total mt-3"
          style="text-align: right; margin-right: 50px; font-weight: bold; font-size: 14px; margin-bottom: 0px;"
        >
          Shipping:
          Free!
        </p>
        <h3
          class="total mt-1 mb-5"
          style="text-align: right; margin-right: 50px;"
        >Total: ${{this.total}}</h3>

        <div style="margin: 0 auto; text-align: center;" v-if="this.total < 4">
          <p @click="home" style="padding: 0px;" class="mt-3 mb-0 link">Continue Browsing</p>
          <v-btn
            class="mt-2"
            style="box-shadow: 0 0 5px rgb(150, 150, 150); width: 100%; max-width: 300px;"
            color="success"
            disabled
          >Checkout</v-btn>
          <p style="text-align: center;" class="mt-2">We have a $4 minimum for orders.</p>
        </div>
        <div style="margin: 0 auto; text-align: center;" v-if="this.total >= 4">
          <p @click="home" style="padding: 0px;" class="mt-3 mb-0 link">Continue Browsing</p>
          <v-btn
            class="mt-2"
            style="box-shadow: 0 0 5px rgb(150, 150, 150); width: 100%; max-width: 300px;"
            color="success"
            @click="goToCheckoutAddress"
          >Checkout</v-btn>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    error: "",
    user: "",
    cartItems: [],
    total: 0
  }),
  mounted() {
    this.scrollToTop();
    this.$store.state.cart.forEach(item => {
      item.dollarAmount = (item.quantity * item.price) / 100;
      this.total = this.total + item.dollarAmount;
      this.cartItems.push(item);
    });
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    goToCheckoutAddress() {
      this.$router.push("/checkoutAddress");
    },
    home() {
      this.$router.push("/");
    },
    increaseQuantity(item) {
      item.quantity++;
      item.dollarAmount = (item.quantity * item.price) / 100;
      this.total = 0;
      this.cartItems.forEach(currentItems => {
        this.total = this.total + currentItems.dollarAmount;
      });
      this.$store.dispatch("addToTotalInCart", 1);
    },
    decreaseQuantity(item) {
      if (item.quantity > 1) {
        item.quantity--;
        item.dollarAmount = (item.quantity * item.price) / 100;
        this.total = 0;
        this.cartItems.forEach(currentItems => {
          this.total = this.total + currentItems.dollarAmount;
        });
        this.$store.dispatch("addToTotalInCart", -1);
      }
    },
    deleteItem(item, indexToDelete) {
      console.log(indexToDelete);
      let updatedCart = [];
      this.cartItems.forEach((currentItem, index) => {
        if (index != indexToDelete) {
          updatedCart.push(currentItem);
        }
      });
      this.cartItems = updatedCart;
      this.total = 0;
      this.cartItems.forEach(currentItems => {
        this.total = this.total + currentItems.dollarAmount;
      });
      this.$store.dispatch("addToTotalInCart", -1 * item.quantity);
      this.$store.dispatch("setEntireCart", this.cartItems);
    }
  }
};
</script>

<style scoped>
.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  .cartBox {
    text-align: left !important;
  }

  .total {
    text-align: left !important;
    margin-left: 10px;
  }
}
</style>
